import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/apyhub.webp';
import screenshot_target from '../../../images/letterfunnel/samuelkaluvuri.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Samuel Kaluvuri"
      firstname="Samuel"
      companyname="Apyhub"
      competition="Rapid en Abstract API"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/samuelkaluvuri.js